export default "/rsETH.a92f55b06d5a848f27f82611029b6d2e.svg";